<div class="tree-view" id="datail-folder-file">
  <!--<div class="loading-content" *ngIf="loading">
    <div class="spinner-border" role="status" >
      <span class="sr-only">Loading...</span>
    </div>
  </div>-->
  <h3 class="treeview-title">Dettaglio </h3>
  <!--<h3 class="treeview-bread">{{itemSelected && itemSelected.section ? (itemSelected.section.nomeSezione + (itemSelected.root ? '' : ' > ') + itemSelected.path.replace(this.separatorePathLogico, ' > ')) : ''}}</h3>-->
  <h3 class="treeview-bread" *ngIf="itemSelected && itemSelected.section">
    <span *ngIf="itemSelected.root;else root_path">
      {{itemSelected.section.nomeSezione}}
    </span>
    <ng-template #root_path>
      <a href="javascript:void(0);" (click)="goSectionRoot()">{{itemSelected.section.nomeSezione}}</a> >
    </ng-template>
    <ng-container *ngFor="let itemPath of split(itemSelected.path); let i=index">
      <span *ngIf="i < split(itemSelected.path).length - 1;else child_path">
        <a href="javascript:void(0);" (click)="goSectionChild(itemSelected.path.split(separatorePathLogico).slice(0, -1).join(separatorePathLogico))">{{itemPath}}</a> >
      </span>
      <ng-template #child_path>
        {{itemPath}}
      </ng-template>
    </ng-container>
  </h3>

  <div *ngIf="!itemSelected">
    <p style="padding: 15px;">Nessuna cartella selezionata</p>
  </div>
  <div *ngIf="itemSelected">
    <p *ngIf="itemSelected.section?.writable" class="header-folder-list">
      <a href="javascript:void(0)" style="margin-right: 15px;"
        (click)="showAddDocModal(itemSelected.section.id, itemSelected)">Aggiungi
        documento<span class="glyphicon glyphicon-file"></span>
      </a>
      <a href="javascript:void(0)" style="margin-right: 15px; border-left: 1px solid #868686; padding-left: 15px;"
        (click)="showAddFolderModal(itemSelected.section.id)"
        *ngIf="itemSelected.section.esn === 'SezioneDocumentazioneAllegata'">Aggiungi
        Cartella<span class="glyphicon glyphicon-folder-close"></span>
      </a>
    </p>
  </div>
  <small id="detail-fold" class="sr-only">dettaglio</small>
  <ul class="tree-view-list tree-view-list-detail" aria-labelledby="detail-fold" role="tree" id="treeView_ul_detail"
      *ngIf="itemSelected?.children?.length > 0"
      (drop)="dropFileDesktop($event)"
      (dragover)="dragOverFileDesktop($event)"
      [ngClass]="isDragOver && 'drag-over'" #content>
    <li class="item-detail-file header-list-file" style="justify-content: normal;">
      <div style="width: 40%;"><span>Nome</span></div>
      <!-- <div style="width: 20%;"><span>Tipo</span></div> -->
      <div style="width: 20%;"><span>Note</span></div>
      <div *ngIf="!minervaWizard" style="width: 10%;"><span>Data Ultima modifica</span></div>
      <div *ngIf="!minervaWizard"
        [appTooltip]="'clicca per ordinare'"
        [appTooltipEnabled]="true"
        (click)="sortColumnTreeView('dataRiferimento')"
        style="width: 15%; cursor: pointer;">
        <span>Data riferimento
          <span>
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </span>
      </div>
      <p style="flex: 0 0 14%;"></p>
    </li>
    <li *ngFor="let item of orderByType(itemSelected.children); let i=index"
        class="item-detail-file" style="justify-content: normal;"
        [id]="i"
        [attr.data-code]="item['code']"
        [attr.data-index]="i"
        [attr.data-first]="i == 0 ? 1 : 0 "
        [attr.data-last]="i == itemSelected.children.length-1?1:0"
        role="treeitem"
        [draggable]="isFile(item) || (!isFile(item) && item.section.isMain)"
        #options
        (dragstart)="dragStart($event, item)"
        (drop)="!isFile(item) && drop($event, item)"
        (dragover)="dragOver($event, item)"
        [ngClass]="isDragAction && 'dragged'">
        <!--[draggable]="isFile(item) || itemSelected.section.isMain"-->
      <div style="width: 40%;">

        <div [appTooltip]="item.name" [appTooltipEnabled]="isFile(item)" class="custom-option">
          <span>
            <ng-container *ngIf="getExpandCollapseClass(item) === 'documento-timbrato'; else icon">
              <img src="img/documentMarked.png" alt="Documento Timbrato"  style=" width: 18px; height: 18px; margin-left: -1.15rem;"/>
            </ng-container>
            <ng-template #icon>
              <i aria-hidden="true" [ngClass]="getExpandCollapseClass(item)"></i>
            </ng-template>
            <a class="tree-item-label" [id]="'elemento-' + i" style="color:#505050" href="javascript:void(0)"
              [ngClass]="{'bold': (item.documento.flagAllegatoPrincipale && item.documento.numeroProtocollo) && isFile(item)}"
              (click)="!isFile(item) && toggleSelection($event,item); isFile(item) && downloadFile(item.code, item.documento); setFocus(item)">
              {{(item.name.length>30)? (item.name | slice:0:27)+'...':(item.name)}}
              <span *ngIf="isFile(item)" class="sr-only">Premendo invio il documento verrà scaricato</span>
              <span
                *ngIf="item.documento.flagAttoPrincipale && item.documento.numeroProtocollo"
                class="glyphicon glyphicon-star"
                style="margin-right: 4px;"
              ></span>
            </a>
          </span>
        </div>
      </div>
      <div style="width: 20%;">
        <div [appTooltip]="item?.documento?.note" [appTooltipEnabled]="(item?.documento?.note?.length > 30) && isFile(item)" class="custom-option">
          <span>
            <i aria-hidden="true"></i>
            <span class="tree-item-label">
              {{ !isFile(item) ? '' : ((item?.documento?.note?.length > 30) ? (item?.documento?.note | slice: 0: 27) + '...' : (item?.documento?.note || '')) }}
            </span>
          </span>
        </div>
      </div>
      <!-- <div style="width: 20%;"><span style="text-transform: uppercase;">{{!isFile(item) ? 'DIR' : getExtFile(item)}}</span></div> -->
      <div *ngIf="!minervaWizard" style="width: 10%;"><span>{{item.dateMod | date:'dd/MM/yyyy'}}</span></div>
      <div *ngIf="!minervaWizard" style="width: 15%;"><span *ngIf=" isFile(item)">{{item.documento?.dataRiferimento | date:'dd/MM/yyyy'}}</span></div>
      <ng-container *ngIf="minervaWizard && itemSelected.section?.writable">
        <app-detail-folder-file-option class="container-fluid"
                                       [item]="item"
                                       (onClickRemoveDocument)="removeDoc($event)"
        ></app-detail-folder-file-option>
      </ng-container>
      <ng-container *ngIf="!minervaWizard">
        <div style="width: 5%">
          <div *ngIf="isFile(item)">
            <ng-container *ngIf="isFilePresent(item?.documento)">
              <a href="javascript:void(0)" *ngIf="canViewFile(item.documento)" aria-label="mostra anteprima documento" (click)="viewDoc(item.documento)">
                <span class="glyphicon glyphicon-eye-open"></span>
              </a>
              <span 
                *ngIf="!canViewFile(item.documento)" 
                class="glyphicon glyphicon-eye-close"
                [appTooltip]="'L’anteprima non è disponibile perché il file supera le dimensioni massime consentite'" 
                [appTooltipEnabled]="checkMaxLimitExceeded(item.documento)">
              </span>
            </ng-container>
            <ng-container *ngIf="!isFilePresent(item?.documento)">
              <a *ngIf="canViewFile(item.documento)">
                <span class="glyphicon glyphicon-eye-open" style="opacity:0.5"></span>
              </a>
              <span *ngIf="!canViewFile(item.documento)" class="glyphicon glyphicon-eye-close" style="opacity:0.5"></span>
            </ng-container>            
          </div>
        </div>
       <app-option-file-component *ngIf="isFile(item)"
                                  [item]="item"
                                  [fascicolo]="fascicolo"
                                  (onOpenDetailModal)="showDetailModal(item.documento)"
                                  (onReturn)="onReturnUpdateCallback($event, item)"
                                  (openModal)="showUploadNewVersionModal($event)"
                                  (onOpenEexportModal)="openExportFile($event)"
                                  (openModalSpostaDoc)="showMoveDocumentModal($event)"
                                  (onOpenProtocolDocModal)="openProtocolDisclaimer($event)"
                                  (openHistoryModal)="showHistoryModal($event)"
                                  (removDoc)="removeDoc($event)"
                                  (removDocFascicolo)="removeDocFromSezioneConFascicolo($event)"
                                  (sezione)="getSezione($event)"
                                  (onOpenUpdateMetadatiModal)="showUpdateMetadatiModal($event)"
                                  (firmaDoc)="firmaDoc($event , item)"
                                  (timbraDoc)="timbraDoc($event , item)"
                                  (annullaProtocolDoc)="annullaProtocolDoc($event , item)">                                
      </app-option-file-component>
       <app-option-dir-component *ngIf="!isFile(item) && !minervaWizard"
                                 [item]="item"
                                 (onOpenUpdateMetadatiModal)="showUpdateMetadatiModal($event)"
                                 (onOpenDeleteDirModal)="showDeleteDirModal($event)"></app-option-dir-component>
      </ng-container>
    </li>
  </ul>
  <div *ngIf="itemSelected && (!itemSelected.children || itemSelected.children.length === 0)" class="no-element"
       (drop)="dropFileDesktop($event)"
       (dragover)="dragOverFileDesktop($event)"
       [ngClass]="isDragOver && 'drag-over'">
    <p style="padding: 15px;">Nessun elemento</p>
  </div>
  <!--<pre>{{itemSelected | json}}</pre>-->
  <!--<pre>{{fileUploadList | json}}</pre>-->
</div>

<!-- MODAL ELIMINA CARTELLA -->
<!-- <div *ngIf="isEliminaDir"> -->
  <div *ngIf="isEliminaDir" class="modal-backdrop fade in" ></div>
  <div id="docShowEliminaDirModal" #docShowEliminaDirModal class="modal fade in" tabindex="-1" role="dialog" [ngStyle]="isEliminaDir && {'display': 'block'}">
    <div class="modal-dialog" [attr.role]="'document'">
      <div class="modal-content">
        <p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
          <button class="btn btn-default-reverse btn-block btn-sm"
                  [attr.data-dismiss]="'modal'" type="button" (click)="isEliminaDir = false;">Chiudi</button>
        </p>
        <div class="col-sm-12 coldx">
          <div class="col-sm-12 coldx">
            <h4>Eliminazione Cartella</h4>
            <div class="row" style="padding: 35px;">
              <p>Verrà eliminata la cartella e tutto il suo contenuto. Continuare?</p>
            </div>
            <div class="row">
              <p class="col-sm-3 col-xs-6">
                <button type="button" class="btn btn-outline-secondary btn-block"
                        (click)="isEliminaDir = false;">Annulla</button>
              </p>
              <p submitButton
                 class="col-sm-3 col-xs-6 col-sm-offset-6"
                 (click)="confermaEliminaDir();" [labelButton]="'Conferma'"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!-- </div> -->
<!-- FINE MODAL ELIMINA CARTELLA -->

<!-- MODAL DETTAGLIO DOCUMENTO -->
  <div *ngIf="showDetail" class="modal-backdrop fade in" ></div>
  <div id="docShowDetailModal" class="modal fade in" role="dialog" style="display: none" [ngStyle]="showDetail && {'display': 'block'}">
    <div class="modal-dialog" [attr.role]="'document'" *ngIf="showDetail">
      <div class="modal-content">
        <p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
          <button class="btn btn-default-reverse btn-block btn-sm"
                  [attr.data-dismiss]="'modal'" type="button" (click)="closeDetailModal()">Chiudi</button>
        </p>
        <div class="col-sm-12 coldx">
          <div class="col-sm-12 coldx">
            <h4>Dettaglio Documento</h4>
            <div class="row">
              <!--{{docToDetail | json}}-->
              <div id="subdocumentazione{{docToDetail.id}}"
                   class="subdocumentazione">
                <form>
                  <div class="row">
                    <div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Posizione'" [valueInput]="docToDetail.posizione"></div>
                    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Titolo'" [valueInput]="docToDetail.titolo"></div>
                    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Tipologia'"
                         [valueInput]="(docToDetail.tipoDocumento ? docToDetail.tipoDocumento.label : '')"></div>
                    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
                       [labelInput]="'Visibilità documento'"
                       [valueInput]="(docToDetail.tipoVisibilitaDocumento ? docToDetail.tipoVisibilitaDocumento.label : '')"></div>
                  </div>
                  <div class="row">
                    <div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Provenienza'"
                         [valueInput]="((docToDetail.provenienza && docToDetail.provenienza.label) ? docToDetail.provenienza.label: '')"></div>
                    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Data riferimento'"
                         [valueInput]="(docToDetail.dataRiferimento ? (docToDetail.dataRiferimento | date:'dd/MM/yyyy'): '')"></div>
                    <div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Nome file'"
                         [valueInput]="(docToDetail.nomeFile ? getNameFile(docToDetail.nomeFile): '')"></div>
                    <div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Numero versione'"
                         [valueInput]="(((docToDetail.versione === '') || !docToDetail.versione) ? '1.0' : docToDetail.versione)"></div>
                  </div>
                  <div class="row">
                    <div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Autore'"
                         [valueInput]="(docToDetail.autore ? docToDetail.autore: '')"></div>
                    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Data caricamento'"
                         [valueInput]="(docToDetail.dataCaricamento ? (docToDetail.dataCaricamento | date:'dd/MM/yyyy'): '')"></div>
                    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Utente ultima modifica'"
                         [valueInput]="(docToDetail.utenteAggiornamento ? docToDetail.utenteAggiornamento: '')"></div>
                    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
                         [labelInput]="'Data ultima modifica'"
                         [valueInput]="(docToDetail.dataAggiornamento ? (docToDetail.dataAggiornamento | date:'dd/MM/yyyy'): '')"></div>
                  </div>
                  <ng-template [ngIf]="docToDetail?.numeroProtocollo || docToDetail?.dataProtocollazione || docToDetail?.oggettoProtocollo">
                    <div class="row">
                      <!-- <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" *ngIf="fascicolo?.numeroFascicoloProtocollo"
                        [labelInput]="'N° fascicolo protocollo'"
                        [valueInput]="fascicolo.numeroFascicoloProtocollo ? fascicolo.numeroFascicoloProtocollo:''"></div> -->
                      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Numero protocollo'"
                        [valueInput]="docToDetail.numeroProtocollo ? docToDetail?.numeroProtocollo :''"></div>
                      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Utente protocollatore'"
                        [valueInput]="docToDetail.utenteProtocollatore ? docToDetail.utenteProtocollatore : ''"></div>
                      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Data protocollazione'"
                        [valueInput]="(docToDetail.dataProtocollazione ? (docToDetail.dataProtocollazione | date:'dd/MM/yyyy HH:mm') : '')"></div>
                      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Registrazione'"
                        [valueInput]="docToDetail.inUscita ? 'IN USCITA': 'IN ENTRATA'"></div>
                    </div>
                    <div class="row">
                        <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'textarea'"
                          [labelInput]="'Mittente/Destinatario'"
                          [valueInput]="(docToDetail.senderReceiver ? docToDetail.senderReceiver : '')"></div>
                    </div>
                    <div class="row">
                        <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'textarea'" [labelInput]="'Oggetto'"
                          [valueInput]="docToDetail.oggettoProtocollo ? docToDetail?.oggettoProtocollo :''"></div>
                    </div>
                    <div class="row">
                      <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'textarea'" [labelInput]="'Oggetto protocollo esteso'"
                        [valueInput]="docToDetail?.oggettoProtocolloEsteso ? docToDetail?.oggettoProtocolloEsteso :''"></div>
                    </div>
                  </ng-template>
                  <div class="row">                  
                  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
                    [labelInput]="'Tipologia produttore'"
                  [valueInput]="(docToDetail?.metadatoDocumento?.tipoUfficioProduttore ? docToDetail?.metadatoDocumento?.tipoUfficioProduttore?.descrizione : '')"></div>
                  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
                    [labelInput]="'Produttore'"
                    [valueInput]="(docToDetail?.metadatoDocumento?.ufficioProduttore)"></div>
                </div>
                <div class="row">
                  <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Modalità di formazione'"
                        [valueInput]="docToDetail?.metadatoDocumento?.modalitaFormazioneDocumento?.descrizione || ''"></div>
                  </div>
                <div class="row">
                  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
                    [labelInput]="'Stato documento'"
                    [valueInput]="(docToDetail?.statoDocumento ? docToDetail.statoDocumento : '')"></div>
                  <div *ngIf="docToDetail?.metadatoDocumento?.motivoAssenzaFirma !== null" 
                    labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
                    [labelInput]="'Tipologia firma'"
                    [valueInput]="docToDetail?.metadatoDocumento?.motivoAssenzaFirma?.descrizione || ''"></div>
                </div>
                <div class="row">
                    <div *ngIf="docToDetail?.metadatoDocumento?.documentoUnico !== null"
                      labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'boolean'"
                      [labelInput]="'Documento unico'"
                      [valueInput]="docToDetail?.metadatoDocumento?.documentoUnico"></div>
                    <div *ngIf="docToDetail?.metadatoDocumento?.numDocumentiScansione !== null"
                      labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
                      [labelInput]="'Numero copie scansione'"
                      [valueInput]="docToDetail?.metadatoDocumento?.numDocumentiScansione"></div>
                </div>
                  <!-- DESCRIZIONE ALLEGATI-->
                  <ng-template [ngIf]="docToDetail?.metadatoDocumento?.documentiScansionati?.length">
                    <div class="row container_fieldset">
                      <fieldset class="form-group">
                        <legend>Descrizione allegati</legend>

                        <div *ngFor="let d of docToDetail?.metadatoDocumento?.documentiScansionati; let i = index">
                          <div labelTextInput class="col-sm-4 bloccodati"
                              [typeLabel]="'text'"
                              [labelInput]="'Titolo'"
                              [valueInput]="d.titolo ?? ''">
                          </div>

                          <div labelTextInput class="col-sm-4 bloccodati"
                              [typeLabel]="'text'"
                              [labelInput]="'Produttore Copia'"
                              [valueInput]="d.produttore ?? ''">
                          </div>

                          <div labelTextInput class="col-sm-4 bloccodati"
                              [typeLabel]="'text'"
                              [labelInput]="'Firmatari'"
                              [valueInput]="d.firmatari ?? ''">
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </ng-template>

                   <!-- METADATI FIRMA-->
                  <ng-template [ngIf]="docToDetail?.metadatoFirmaDocumenti?.length">
                    <div class="row container_fieldset">
                      <ng-container *ngFor="let m of docToDetail.metadatoFirmaDocumenti; let idx = index">
                        <fieldset class="form-group">
                          <legend>Metadati di firma - {{ m.firmatario}}</legend>      
                           
                            <div labelTextInput class="col-sm-4 bloccodati"
                                [typeLabel]="'text'"
                                [labelInput]="'Esito verifica firma'"
                                [valueInput]="m.esitoVerifica?.descrizione ?? ''">
                            </div>

                            <div labelTextInput class="col-sm-4 bloccodati"
                                [typeLabel]="'text'"
                                [labelInput]="'Nome firmatario'"
                                [valueInput]="m.firmatario ?? ''">
                            </div>

                            <div labelTextInput class="col-sm-4 bloccodati"
                                [typeLabel]="'text'"
                                [labelInput]="'Data/Ora firma'"
                                [valueInput]="m.validitaDataFirma ? (m.validitaDataFirma | date: 'dd/MM/yyyy HH:mm:ss') : ''">
                            </div>

                            <div labelTextInput class="col-sm-4 bloccodati"
                                [typeLabel]="'text'"
                                [labelInput]="'Identificativo certificato'"
                                [valueInput]="m.identificativoCertificato ?? ''">
                            </div>

                            <div labelTextInput class="col-sm-4 bloccodati"
                                [typeLabel]="'text'"
                                [labelInput]="'Autorità di certificazione'"
                                [valueInput]="m.caEmittente ?? ''">
                            </div>

                            <div labelTextInput class="col-sm-4 bloccodati"
                                [typeLabel]="'text'"
                                [labelInput]="'Tipo di firma'"
                                [valueInput]="m.tipoFirma ?? ''">
                            </div>

                            <div labelTextInput class="col-sm-6 bloccodati"
                                [typeLabel]="'text'"
                                [labelInput]="'Organizzazione'"
                                [valueInput]="m.organizzazione ?? ''">
                            </div>

                            <div labelTextInput class="col-sm-6 bloccodati"
                                [typeLabel]="'text'"
                                [labelInput]="'Data di scadenza certificato'"
                                [valueInput]="m.dataScadenzaFirma ? (m.dataScadenzaFirma | date:'dd/MM/yyyy HH:mm:ss') : ''">
                            </div>
                        </fieldset>
                      </ng-container>
                    </div>
                  </ng-template>

                  <!-- PROTOCOLLO ANNULLATO -->
                  <ng-template [ngIf]="docToDetail?.statoDocumento === 'ANNULLATO'">
                    <div class="row container_fieldset">
                      <fieldset class="form-group">
                        <legend>Protocollo annullato</legend>

                        <div labelTextInput class="col-sm-4 bloccodati"
                            [typeLabel]="'text'"
                            [labelInput]="'Estremi del Provvedimento'"
                            [valueInput]="docToDetail?.estremiProvvedimento ?? ''">
                        </div>

                        <div labelTextInput class="col-sm-4 bloccodati"
                            [typeLabel]="'text'"
                            [labelInput]="'Data Annullamento'"
                            [valueInput]="docToDetail?.dataAnnullamento ? (docToDetail.dataAnnullamento | date:'dd/MM/yyyy') : ''">
                        </div>

                        <div labelTextInput class="col-sm-4 bloccodati"
                            [typeLabel]="'text'"
                            [labelInput]="'Identificativo operatore'"
                            [valueInput]="docToDetail?.identificativoOperatore ?? ''">
                        </div>
                      </fieldset>
                    </div>
                  </ng-template>

                   <!-- FIRMA NON VALIDA -->
                   
                  <ng-template [ngIf]="hasFirmaNonValida(docToDetail)">
                      <div class="row container_fieldset">
                          <fieldset class="form-group">
                            <legend>Firma non valida</legend>
                            <div labelTextInput class="col-sm-6 bloccodati"
                                [typeLabel]="'text'"
                                [labelInput]="'Utente operazione'"
                                [valueInput]="(docToDetail?.autore ? docToDetail.autore : '')">
                            </div>
                            <div labelTextInput class="col-sm-6 bloccodati"
                                [typeLabel]="'text'"
                                [labelInput]="'Data e ora caricamento documento'"
                                [valueInput]="(docToDetail?.dataCaricamento ? (docToDetail.dataCaricamento | date:'dd/MM/yyyy HH:mm:ss') : '')">
                            </div>
                          </fieldset>
                      </div>
                  </ng-template>

                  <div class="row">
                    <div class="col-sm-12 bloccodati">
                      <p>
                        <label class="col-sm-12">Note</label>
                        <span class="longtext" *ngIf="docToDetail.note">{{ docToDetail.note }}</span>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!-- FINE MODAL DETTAGLIO DOCUMENTO -->
